import posts from "./blogPosts.json";

export interface BlogPost {
  title: string;
  description: string;
  image: string;
  date: string;
  slug: string;
}

export default posts as BlogPost[];
